module.exports = __webpack_public_path__ + "img/4.e1464228.jpg";